import { Baby, Box, Brain, ChevronRight, Microscope, PersonStanding } from "lucide-react";
import { gradientVars, useRecallT } from "../anatomyRecall/ui";
import "../anatomyRecall/anatomyRecall.css";

/*
  The five quiz entry cards — same structure as the mobile Quiz screen:
  Histology · Embryology · Anatomy Quiz · Identify Anatomy · Anatomy Recall (NEW).
*/
export const QUIZ_CATEGORY_CARDS = [
  {
    key: "histology",
    titleKey: "catHistology",
    title: "Histology",
    subKey: "catHistologySub",
    sub: "Identify cells, tissues & structures in real slides",
    Icon: Microscope,
    light: ["#5B4BFF", "#7C3AED", "#A855F7"],
    dark: ["#4C1D95", "#6D28D9", "#8B5CF6"],
  },
  {
    key: "embryology",
    titleKey: "catEmbryology",
    title: "Embryology",
    subKey: "catEmbryologySub",
    sub: "Test your knowledge of animal embryonic development",
    Icon: Baby,
    light: ["#0EA5E9", "#06B6D4", "#22D3EE"],
    dark: ["#0C4A6E", "#0284C7", "#38BDF8"],
  },
  {
    key: "anatomy",
    titleKey: "catAnatomyQuiz",
    title: "Anatomy Quiz",
    subKey: "catAnatomyQuizSub",
    sub: "MCQs & short questions on human anatomy",
    Icon: PersonStanding,
    light: ["#DC2626", "#EF4444", "#FB7185"],
    dark: ["#7F1D1D", "#BE123C", "#E11D48"],
  },
  {
    key: "identify",
    titleKey: "catIdentify",
    title: "Identify Anatomy",
    subKey: "catIdentifySub",
    sub: "Select and identify structures on interactive 3D models",
    Icon: Box,
    light: ["#BE123C", "#E11D48", "#F472B6"],
    dark: ["#881337", "#BE185D", "#E8467C"],
  },
  {
    key: "recall",
    titleKey: "catRecall",
    title: "Anatomy Recall",
    subKey: "catRecallSub",
    sub: "Recall and locate structures from memory",
    Icon: Brain,
    isNew: true,
    light: ["#BE185D", "#DB2777", "#F472B6"],
    dark: ["#831843", "#BE185D", "#EC4899"],
  },
];

export default function QuizCategoryCards({ dark, onSelect }) {
  const { t } = useRecallT();
  return (
    <div className={`ar-root ${dark ? "ar-dark" : ""}`}>
      <div className="qc-grid">
        {QUIZ_CATEGORY_CARDS.map((card, i) => {
          const { Icon } = card;
          return (
            <button
              key={card.key}
              type="button"
              className="qc-card"
              style={{ ...gradientVars(dark ? card.dark : card.light), "--i": i }}
              onClick={() => onSelect(card.key)}
              data-testid={`quiz-category-${card.key}`}
            >
              <span className="qc-watermark" aria-hidden>
                <Icon />
              </span>
              <span className="qc-icon" aria-hidden>
                <Icon />
              </span>
              <span className="qc-text">
                <span className="qc-title">{t(card.titleKey, card.title)}</span>
                <span className="qc-sub">
                  {t(card.subKey, card.sub)}
                </span>
              </span>
              {card.isNew ? <span className="qc-badge">{t("newBadge", "NEW")}</span> : null}
              <span className="qc-chevron" aria-hidden>
                <ChevronRight />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
